import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import it from './it.json';

export const translations = {
  en,
  it,
};

export type Language = keyof typeof translations;

/**
 * Array of all supported languages
 * Useful for validation and iteration
 */
export const SUPPORTED_LANGUAGES: Language[] = Object.keys(
  translations
) as Language[];

// Detect browser language or fallback to Italian (attualmente lo inseriamo direttamente in italiano)
// const browserLanguage = navigator.language.split('-')[0];
// const defaultLanguage: Language =
//   (SUPPORTED_LANGUAGES.includes(browserLanguage as Language)
//     ? browserLanguage
//     : 'it') as Language;
// Get default language: try localStorage first, then fallback to Italian
const getDefaultLanguage = (): Language => {
  const stored = typeof window !== 'undefined' ? localStorage.getItem('language') : null;
  if (stored && SUPPORTED_LANGUAGES.includes(stored as Language)) {
    return stored as Language;
  }
  return 'it';
};

const defaultLanguage = getDefaultLanguage();

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      en: { translation: en },
      it: { translation: it },
    },
    lng: defaultLanguage, // default language
    fallbackLng: 'it', // fallback language
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    react: {
      useSuspense: false, // disable suspense for now
    },
  });

// Persist language preference to localStorage when it changes
i18n.on('languageChanged', (language) => {
  localStorage.setItem('language', language);
});

export default i18n;
